<template>
  <div class="p-4" v-if="surveys.length > 0">
    <HistoryCard
      v-for="(survey, index) in surveys"
      :key="index"
      :survey="survey"
      :index="index"
    />
  </div>
  <div class="p-4" v-else>
    <h1 class="text-center mt-10 text-lg text-gray-500">
      پرسشنامه ای موجود نیست
    </h1>
  </div>

  <div class="mb-10 flex flex-col justify-center m-5" v-if="surveys.length > 0">
    <Button
      class=""
      @click="upload"
      :disabled="loading"
    >
      <LoadingSpinner v-if="loading" />
      ذخیره
    </Button>
    <Button type="button" class="mt-3" v-on:click="saveFile()">دانلود</Button>
  </div>
</template>

<script>
import Button from "../components/Button";
import HistoryCard from "./HistoryCard";
import axios from "axios";
import LoadingSpinner from "../components/LoadingSpinner";

export default {
  name: "History",
  components: { LoadingSpinner, HistoryCard, Button },
  data() {
    return {
      loading: false,
      surveys: localStorage.getItem("surveys")
        ? JSON.parse(localStorage.getItem("surveys"))
        : [],
    };
  },
  methods: {
    upload() {
      console.log(this.surveys);
      this.loading = true;
      axios
        .post("http://surveyApi.tabarok.ir/insertquestion", this.surveys)
        .then(() => {
          this.$store.dispatch("emptySurveys");
          this.surveys = [];
          this.$swal({
            icon: "success",
            title: "موفق",
            text: "پرسشنامه ها با موفقیت ذخیره شدند.",
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        })
        .catch((err) => {
          console.log(err);
          this.$swal({
            icon: "error",
            title: "خطا",
            text: err.message,
            confirmButtonColor: "#fcd34d",
            confirmButtonText: "باشه",
          });
        })
        .finally(() => {
          this.loading = false;
        });
    },
    saveFile() {
      const data = JSON.stringify(this.surveys);
      const blob = new Blob([data], { type: "text/plain" });
      const e = document.createEvent("MouseEvents"),
        a = document.createElement("a");
      a.download = "test.json";
      a.href = window.URL.createObjectURL(blob);
      a.dataset.downloadurl = ["text/json", a.download, a.href].join(":");
      e.initEvent("click",true,false,window,0,0,0,0,0,false,false,false,false,0,null);
      a.dispatchEvent(e);
    },
  },
};
</script>
